export default "__VITE_ASSET__E8FplXyV__"